module.exports = __webpack_public_path__ + "img/right.be5030ca.webp";